// SMUSH! theme — minimal client JS
(function(){
  // Update cart count when user adds something (best-effort via fetch)
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(){
      // Shopify handles navigation; nothing to do here for the basic flow
    });
  });
})();
